import { useMemo } from 'react'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'

export default function AttendanceIntelligenceArrivalChart({ arrivalCurve }) {
  const options = useMemo(() => {
    const buckets = arrivalCurve || []
    const categories = buckets.map((bucket) => bucket.label)
    const data = buckets.map((bucket) => bucket.scanCount)

    return {
      chart: {
        type: 'column',
        height: 320,
        backgroundColor: 'transparent',
        spacing: [12, 8, 8, 8],
      },
      title: { text: undefined },
      credits: { enabled: false },
      legend: { enabled: false },
      xAxis: {
        categories,
        title: { text: null },
        lineColor: '#e5e7eb',
        tickColor: '#e5e7eb',
        labels: {
          rotation: -45,
          style: { color: '#6b7280', fontSize: '11px' },
        },
      },
      yAxis: {
        min: 0,
        title: { text: 'Scans' },
        gridLineColor: '#eef0f2',
        labels: {
          style: { color: '#6b7280', fontSize: '12px' },
        },
      },
      tooltip: {
        valueSuffix: ' scans',
        valueDecimals: 0,
      },
      plotOptions: {
        column: {
          borderWidth: 0,
          pointPadding: 0.1,
          groupPadding: 0.08,
          color: '#3b82f6',
        },
      },
      series: [
        {
          name: 'Scans',
          data,
        },
      ],
    }
  }, [arrivalCurve])

  if (!arrivalCurve?.length) {
    return (
      <p className="text-muted small mb-0">
        No scan timing data yet for this event.
      </p>
    )
  }

  return <HighchartsReact highcharts={Highcharts} options={options} />
}
